<template>
  <div>
    <BlockUI v-if="loading" message="Loading">
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <v-card>
      <v-toolbar dense class="elevation-0">
        <v-toolbar-title>{{ instance.code }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small outline :color="$options.filters.statusBgColor(instance.status)">{{ instance.status }}</v-chip>
        <v-btn flat icon color="red" :href="printoutUrl" target="_blank">
          <v-icon>mdi-adobe-acrobat</v-icon>
        </v-btn>
        <v-btn flat icon color="primary" @click="print">
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn flat icon color="warning" @click="locked = !locked" :disabled="isCompleted">
          <v-icon>{{ (locked) ? 'lock' : 'lock_open' }}</v-icon>
        </v-btn>
        <v-btn flat icon @click="gotoList">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="valid" ref="qform" lazy-validation>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                required
                :rules="[v => !!v || 'Name is required']"
                label="Name"
                v-model="instance.name"
                :disabled="!isEditable"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-select return-object required :rules="[v => !!v || 'Customer is required']"
                :items="customerItems"
                v-model="instance.customer"
                label="Customer"
                item-value="id"
                item-text="name"
                :disabled="!isEditable"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <n-chip-date-picker
                v-model="instance.bookDate"
                :error="!instance.bookDate"
                :required="true"
                :is-disabled="!isEditable"
                label="Date"></n-chip-date-picker>
            </v-flex>
            <v-flex xs12 md12>
              <label>Remark</label>
              <!-- <vue-editor v-model="instance.remark" :disabled="!isEditable"></vue-editor> -->
              <ckeditor :editor="editor" v-model="instance.remark" :disabled="!isEditable"></ckeditor>
            </v-flex>
            <v-flex xs12 md12>
              <v-tabs v-model="tabActive" color="cyan" dark slider-color="yellow">
                <v-tab ripple>
                  Items
                </v-tab>
                <v-tab ripple>
                  Invoices
                </v-tab>
                <v-tab-item>
                  <items-data-table v-model="instance.items" :is-disabled="!isEditable" :vat-included="true"></items-data-table>
                </v-tab-item>
                <v-tab-item>
                  <invoices-data-table v-model="instance"></invoices-data-table>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pl-3 pr-3">
        <v-btn dark class="grey darken-2" @click.native="gotoList">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn outline color="primary" @click.native="complete" :disabled="!valid" v-if="isDraft && locked" :loading="loading">Complete</v-btn>
        <v-btn outline color="red" @click.native="remove" :disabled="!valid" v-if="isDraft && locked" :loading="loading">Delete</v-btn>
        <v-btn outline color="success" @click.native="save" :disabled="!valid" v-if="isDraft && !locked" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import swal from 'sweetalert2'
import ItemsDataTable from '@/components/item/ItemList'
import InvoicesDataTable from './invoiceList'
import NChipDatePicker from '@/components/date-picker/NChipDatePicker'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'QuotationShow',
  moduleName: 'Quotation',
  props: ['id'],
  components: { VueEditor, NChipDatePicker, ItemsDataTable, InvoicesDataTable },
  data () {
    return {
      loading: false,
      valid: false,
      locked: true,
      customerItems: [],
      tabActive: 'itemListTab',
      editor: ClassicEditor,
      instance: {
        items: []
      }
    }
  },
  computed: {
    printoutUrl () {
      return this.$store.getters['quotation/printoutUrl'](this.instance.id)
    },
    isEditable() {
      return this.isDraft && !this.locked
    },
    isDraft() {
      return (this.instance.status) && (this.instance.status === 'DRAFT')
    },
    isCompleted() {
      return (this.instance.status) && (this.instance.status === 'COMPLETED')
    }
  },
  methods: {
    reload: _.debounce((self) => {
      self.loading = true
      self.$store.dispatch('quotation/fetchItem', self.id)
        .then((response) => {
          self.instance = response.data
          self.loading = false
        }).catch((error)=>{
          self.loading = false
          swal('Error!', error.message, 'error')
        })
    }, 1000),
    gotoList () {
      this.$router.push('/quotations/list')
    },
    print () {
      this.$store.dispatch('printPdf', this.printoutUrl)
    },
    save() {
      if (this.$refs.qform.validate() && this.instance.bookDate) {
        swal({
          title: `Save ${this.$options.moduleName}!`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Close',
          confirmButtonText: 'Confirm'
        }).then(result => {
          if (result.value) {
            this.loading = true
            this.$store.dispatch('quotation/update', this.instance)
            .then((response) => {
              this.loading = false
              this.reload(this)
              this.$snotify.success(`Save ${this.$options.moduleName}.`, 'Success!')
            }).catch(error => {
              this.loading = false
              this.$snotify.error(`${error.response.data.error}:${error.response.data.message}`, 'Fail!')
            })
          }
        })
      }
    },
    complete () {
      if (this.$refs.qform.validate() && this.instance.bookDate) {
        swal({
          title: `Complete ${this.$options.moduleName}!`,
          text: 'Please, confirm your action. This item cannot be modified afterward!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Close',
          confirmButtonText: 'Confirm'
        }).then(result => {
          if (result.value) {
            this.loading = true
            this.$store.dispatch('quotation/complete', this.instance)
            .then(response => {
              this.loading = false
              this.reload(this)
              this.$snotify.success(`Complete ${this.$options.moduleName}.`, 'Success!')
            }).catch(error => {
              this.loading = false
              this.$snotify.error(`${error.response.data.error}:${error.response.data.message}`, 'Fail!')
            })
          }
        })
      }
    },
    remove () {
      if (this.$refs.qform.validate()) {
        swal({
          title: `Delete ${this.$options.moduleName}!`,
          text: 'Please, confirm your action. This item cannot be modified afterward!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Close',
          confirmButtonText: 'Confirm'
        }).then(result => {
          if (result.value) {
            this.loading = true
            this.$store.dispatch('quotation/delete', this.instance)
            .then(response => {
              this.loading = false
              this.$snotify.success(`Delete ${this.$options.moduleName}.`, 'Success!')
              this.$router.push('/quotations/list')
            }).catch(error => {
              this.loading = false
              this.$snotify.error(`${error.response.data.error}:${error.response.data.message}`, 'Fail!')
            })
          }
        })
      }
    }
  },
  mounted () {
    this.$store.dispatch('customer/loadCustomerItems')
      .then((response) => {
        this.customerItems = response.data
      })
    this.reload(this)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/quotations/show.vue